import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';


const propTypes = {
  openEntryModal: PropTypes.func.isRequired,
};

const AddUserButton = (props) => {
  const { openEntryModal } = props;
  return (
    <Button bsStyle="primary" onClick={() => { openEntryModal(); }}>Add User</Button>
  );
};

AddUserButton.propTypes = propTypes;

export default AddUserButton;
